import { jwtDecode } from "jwt-decode";

import type { TokenClaims } from "../lib/claims";
import type { StoredSession } from "./session-storage";

/** The session's claims: the ID token's, with the access token's taking precedence. */
export const claimsFromSession = (session: StoredSession): TokenClaims => ({
  ...(session.idToken ? jwtDecode<TokenClaims>(session.idToken) : {}),
  ...jwtDecode<TokenClaims>(session.accessToken),
});
